﻿<!-- 121.01 -->
<ng-container *ngIf="mortgageApplication?.isRemortgage">
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.IsPartToRemortgageCode"
    [(value)]="applicant.IsPartToRemortgageCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="['Applicant_' + applicantIndex + '.IsPartToRemortgageCode']"
    (valueChange)="setCustomerTypeIfRemortgage(); updateApplicantMortgagePayOffDependencies()"
  >
  </boi-form-radio-button>
</ng-container>
<!-- 33.3a & 33.3b -->
<boi-form-option-list
  [labelName]="referenceDataLabels.CustomerType"
  [(value)]="applicant.CustomerTypeCode"
  [optionList]="customerTypeOptionList"
  [propertyNames]="['Applicant_' + applicantIndex + '.CustomerTypeCode']"
  [isFieldDisabled]="
    applicant.IsPartToRemortgageCode === referenceDataOptionLists.AnswerTypeYes ||
    mortgageApplication?.isBuyToLet ||
    mortgageApplication?.IsFactFindReadOnly ||
    mortgageApplication?.IsApplicationReadOnly
  "
>
</boi-form-option-list>
<!-- 25 -->
<boi-form-option-list
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.Title"
  [(value)]="applicant.TitleCode"
  [optionList]="referenceDataOptionLists.Title"
  [propertyNames]="['Applicant_' + applicantIndex + '.TitleCode']"
>
</boi-form-option-list>
<!-- 26 -->
<boi-form-text-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.FirstName"
  [(value)]="applicant.Forename"
  [propertyNames]="['Applicant_' + applicantIndex + '.Forename']"
  [fieldMaxLength]="30"
>
</boi-form-text-input>
<boi-form-information-box [decoration]="'question-mark'" [message]="referenceDataLabels.MiddleNameWarning">
</boi-form-information-box>
<!-- 27 -->
<boi-form-text-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.MiddleName"
  [(value)]="applicant.MiddleName"
  [propertyNames]="['Applicant_' + applicantIndex + '.MiddleName']"
  [fieldMaxLength]="30"
>
</boi-form-text-input>
<!-- 28 -->
<boi-form-text-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.Surname"
  [(value)]="applicant.Surname"
  [fieldMaxLength]="30"
  [propertyNames]="['Applicant_' + applicantIndex + '.Surname']"
>
</boi-form-text-input>
<!-- 31 -->
<boi-form-radio-button
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.WereYouKnownByAnyOtherSurnamesId"
  [(value)]="applicant.UsedPreviousSurnameCode"
  [optionList]="referenceDataOptionLists.AnswerType"
  [propertyNames]="['Applicant_' + applicantIndex + '.UsedPreviousSurnameCode']"
>
</boi-form-radio-button>
<!-- 32 -->
<ng-container *ngIf="applicant.hadAPreviousSurname()">
  <boi-form-text-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.MostRecentSurnameId"
    [(value)]="applicant.PreviousSurname"
    [propertyNames]="['Applicant_' + applicantIndex + '.PreviousSurname']"
    [fieldMaxLength]="30"
  >
  </boi-form-text-input>
</ng-container>
<!-- 29 -->
<ng-container *ngIf="!mortgageApplication.IsAip">
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.GenderId"
    [(value)]="applicant.GenderCode"
    [optionList]="referenceDataOptionLists.Gender"
    [propertyNames]="['Applicant_' + applicantIndex + '.GenderCode']"
  >
  </boi-form-radio-button>
</ng-container>
<!-- 30 -->
<boi-form-option-list
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.MaritalStatus"
  [(value)]="applicant.MaritalStatusCode"
  [optionList]="referenceDataOptionLists.MaritalStatus"
  [propertyNames]="['Applicant_' + applicantIndex + '.MaritalStatusCode']"
>
</boi-form-option-list>
<!-- 33 & 33.1 & 33.2 -->
<boi-form-date
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.DateOfBirthId"
  [(value)]="applicant.DateOfBirth"
  [propertyNames]="['Applicant_' + applicantIndex + '.DateOfBirth']"
  (valueChange)="updateAgeAtMortgageTerm()"
>
</boi-form-date>
<!-- 45 -->
<ng-container *ngIf="!mortgageApplication.IsFactFind">
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.CountryOfBirthId"
    [(value)]="applicant.BirthCountryCode"
    [optionList]="referenceDataOptionLists.Country"
    [isVirtualizationEnable]="true"
    [propertyNames]="['Applicant_' + applicantIndex + '.BirthCountryCode']"
  >
  </boi-form-option-list>
</ng-container>
<!-- 46 -->
<boi-form-option-list
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.NationalityId"
  [(value)]="applicant.NationalityCode"
  [optionList]="referenceDataOptionLists.Nationality"
  [isVirtualizationEnable]="true"
  [propertyNames]="['Applicant_' + applicantIndex + '.NationalityCode']"
></boi-form-option-list>
<!-- 46.1 -->
<ng-container *ngIf="mortgageApplication.IsFullApp">
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.LengthOfUKResidency"
    [(value)]="applicant.LengthOfUKResidencyCode"
    [optionList]="referenceDataOptionLists.LengthOfUKResidency"
    [propertyNames]="['Applicant_' + applicantIndex + '.LengthOfUKResidencyCode']"
  >
  </boi-form-option-list>
</ng-container>
<!-- 37 -->
<ng-container *ngIf="!mortgageApplication.IsFactFind && mortgageApplication.IsFullApp">
  <boi-form-text-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.NationalInsuranceNumberId"
    [(value)]="applicant.NationalInsuranceNumber"
    [propertyNames]="['Applicant_' + applicantIndex + '.NationalInsuranceNumber']"
    [fieldMaxLength]="9"
  >
  </boi-form-text-input>
</ng-container>

<!-- 41.1-->
<ng-container *ngIf="isApplicantSponsorFieldVisible()">
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.IsLoanSponsorCode"
    [(value)]="applicant.IsLoanSponsorCode"
    [optionList]="referenceDataOptionLists.AnswerType"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.IsLoanSponsorCode',
      'Applicant_' + applicantIndex + '.ApplicantIsLoanSponsorCode'
    ]"
    (valueChange)="onSponsorCodeUpdate()"
  >
  </boi-form-radio-button>
</ng-container>

<ng-container
  *ngIf="mortgageApplication.IsFullApp || (mortgageApplication.isAdvisedCase && mortgageApplication.IsFactFind)"
>
  <!-- 41.2 -->
  <ng-container
    *ngIf="
      mortgageApplication.IsFullApp &&
      applicant.IsLoanSponsorCode === referenceDataOptionLists.AnswerTypeYes &&
      isResidentialLoanGroupTypeFirstStart()
    "
  >
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.IsOnDeedsCode"
      [(value)]="applicant.IsOnDeedsCode"
      [optionList]="referenceDataOptionLists.AnswerType"
      [propertyNames]="['Applicant_' + applicantIndex + '.IsOnDeedsCode']"
    >
    </boi-form-radio-button>
  </ng-container>

  <div class="vo-separator-line my-15"></div>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <div class="form-element subtitle-section my-15">
      <p class="vo-heading-regular-20">{{ referenceDataLabels.MortgageOfferLabel | localizeLabel }}</p>
    </div>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp && applicantIndex === 0">
    <div class="form-element subtitle-section my-13">
      <p>{{ referenceDataLabels.OnlineOfferInfo | localizeLabel }}</p>
    </div>

    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.OfferDistributionLabel"
      [value]="applicant.OfferDistributionChannel"
      [optionList]="referenceDataOptionLists.OfferDistribution"
      (valueChange)="onOfferDistributionChange($event, applicantIndex)"
      [propertyNames]="['Applicant_' + applicantIndex + '.OfferDistributionChannel']"
      [tooltipName]="referenceDataLabels.OfferDistributionChannel"
    >
    </boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <boi-form-information-box [decoration]="'exclamation-mark'" [message]="informationBoxMessage">
    </boi-form-information-box>
  </ng-container>
</ng-container>

<ng-container *ngIf="!mortgageApplication.IsAip">
  <!-- 38 -->
  <boi-form-text-input
    #applicantEmailAddress
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.ApplicantEmailAddress"
    [forceRequired]="
      mortgageApplication?.Applicants[0]?.OfferDistributionChannel === referenceDataOptionLists.OfferDistributionOnline
    "
    [(value)]="applicant.EmailAddress"
    [propertyNames]="['Applicant_' + applicantIndex + '.EmailAddress']"
  >
  </boi-form-text-input>
  <!-- 39 -->
  <boi-form-text-input
    #applicantMobilePhoneNumber
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.MobilePhoneNumberId"
    [forceRequired]="
      mortgageApplication?.Applicants[0]?.OfferDistributionChannel ===
        referenceDataOptionLists.OfferDistributionOnline || mortgageApplication.IsFactFind
    "
    [(value)]="applicant.MobileTelephoneNumber"
    [propertyNames]="['Applicant_' + applicantIndex + '.MobileTelephoneNumber']"
    [fieldMaxLength]="maxLengthPhoneNumber"
  >
  </boi-form-text-input>
  <!-- 40 -->
  <boi-form-text-input
    #applicantHomePhoneNumber
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.HomePhoneNumberId"
    [forceRequired]="mortgageApplication.IsFactFind"
    [(value)]="applicant.HomeTelephoneNumber"
    [propertyNames]="['Applicant_' + applicantIndex + '.HomeTelephoneNumber']"
    [fieldMaxLength]="20"
  >
  </boi-form-text-input>
  <!-- 41 -->
  <boi-form-text-input
    #applicantWorkPhoneNumber
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.WorkPhoneNumberId"
    [forceRequired]="mortgageApplication.IsFactFind"
    [(value)]="applicant.WorkTelephoneNumber"
    [propertyNames]="['Applicant_' + applicantIndex + '.WorkTelephoneNumber']"
    [fieldMaxLength]="20"
  >
  </boi-form-text-input>
</ng-container>

<ng-container *ngIf="mortgageApplication.IsFullApp">
  <div class="vo-separator-line my-15"></div>

  <ng-container *ngIf="shouldDisplaySolicitorHeader()">
    <ng-container
      *ngIf="
        applicant.IsLoanSponsorCode === referenceDataOptionLists.AnswerTypeYes &&
        applicant.IsOnDeedsCode === referenceDataOptionLists.AnswerTypeNo
      "
    >
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [includeOkButton]="true"
        [message]="referenceDataLabels.ApplicantSolicitorHeader"
      ></boi-form-information-box>
    </ng-container>

    <ng-container
      *ngIf="isLoanGroupTypeFamilyLink() && applicant.CustomerTypeCode === referenceDataLabels.CustomerTypeRemortgaging"
    >
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [includeOkButton]="true"
        [message]="referenceDataLabels.ApplicantSolicitorHeaderForFamilyLink"
      ></boi-form-information-box>
    </ng-container>

    <ng-container *ngIf="isLoanGroupTypeRetirementLink()">
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [includeOkButton]="true"
        [message]="referenceDataLabels.ApplicantSolicitorHeaderForRetirementLink"
      ></boi-form-information-box>
    </ng-container>

    <!-- 41.3b -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.KnowILASolicitorDetailsCode"
      [(value)]="applicant.KnowILASolicitorDetailsCode"
      [optionList]="referenceDataOptionLists.AnswerType"
      [propertyNames]="['Applicant_' + applicantIndex + '.KnowILASolicitorDetailsCode']"
    >
    </boi-form-radio-button>

    <ng-container *ngIf="applicant.KnowILASolicitorDetailsCode === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.ApplicantSolicitorName"
        [(value)]="applicant.SolicitorAddress.Name"
        [propertyNames]="['Applicant_' + applicantIndex + '.SolicitorAddress.Name']"
        [fieldMaxLength]="30"
      >
      </boi-form-text-input>

      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.ContactTelephoneNumber"
        [(value)]="applicant.SolicitorAddress.PhoneNumber"
        [propertyNames]="['Applicant_' + applicantIndex + '.SolicitorAddress.PhoneNumber']"
        [fieldMaxLength]="30"
      >
      </boi-form-text-input>

      <boi-form-address
        [labelName]="referenceDataLabels.SolicitorAddress"
        [(address)]="applicant.SolicitorAddress"
        [addressLine1Required]="true"
        [mortgageApplication]="mortgageApplication"
        [propertyName]="['Applicant_' + applicantIndex + '.SolicitorAddress']"
        [showCountryCode]="true"
        [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
      >
      </boi-form-address>
    </ng-container>
  </ng-container>
</ng-container>
